module.exports = __webpack_public_path__ + "static/media/bgWabi.9aec268c.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/bgWabi.png
// module id = 1271
// module chunks = 0